import { jsx as t } from "react/jsx-runtime";
import { CircularProgress as r } from "@mui/joy";
import { parseDesignVariant as s } from "../../../../utils/DesignVariantsUtils.js";
const i = ({ designVariant: i2, ...a }) => {
  const o = i2 ? { ...a, ...s(i2) } : a;
  return t(r, { "data-testid": o["data-testid"], ...o });
};
export {
  i as default
};
